import { render } from "./Modal.vue?vue&type=template&id=79526700&scoped=true"
import script from "./Modal.vue?vue&type=script&lang=js"
export * from "./Modal.vue?vue&type=script&lang=js"

import "./Modal.vue?vue&type=style&index=0&id=79526700&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-79526700"

export default script